import { createContext, useState } from "react";
import { LoadingData, LoadingDataRequestsType, SearchVehicleData, SearchVehicleDataContextType, SetSearchVehicleDataContextType, Vehicle } from "./types";
import { carVehicleDataRequest } from "@/utils/requests/laximo/carVehicleDataRequest";

/** Контекст для данных поиска автомобиля */
export const SearchVehicleByVinDataContext = createContext<SetSearchVehicleDataContextType & SearchVehicleDataContextType & LoadingData & LoadingDataRequestsType | null>(null);

/** Провайдер для данных поиска автомобиля */
export const SearchVehicleByVinDataProvider = ({ children }: { children: React.ReactNode }) => {
    const [vin, setVin] = useState<string>('');
    const [carNumber, setCarNumber] = useState<string>('');
    const [carNumberRegion, setCarNumberRegion] = useState<string>('');
    const [ssd, setSsd] = useState<string>('');
    const [vehicleId, setVehicleId] = useState<string>('');
    const [catalog, setCatalog] = useState<string>('');
	const [searchVehicle, setSearchVehicle] = useState<SearchVehicleData | null>(null);
	const [vehicle, setVehicle] = useState<any>({});
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>("");

    /** Загрузка данных автомобиля */
    const findVehicle: (LoadingDataRequestsType['findVehicle']) = (vehicle: Vehicle) => {
        if (vehicle !== undefined) {
            const { vehicleid, catalog, ssd } = vehicle as Vehicle;
            setVehicleId(vehicleid);
            setSsd(ssd);
            setCatalog(catalog);
            carVehicleDataRequest(vehicleid, catalog, ssd)
                .then(vehicleData => {
                    setVehicle(vehicleData);
                }).catch(error => {
                    setError(error.message);
                });
        }
    };

    return (
        <SearchVehicleByVinDataContext.Provider value={{ vin, carNumber, carNumberRegion, ssd, vehicleId, catalog, searchVehicle, vehicle, isLoading, error, setIsLoading, setError: setError, setVin, setCarNumber, setCarNumberRegion, setSsd, setVehicleId, setCatalog, setSearchVehicle, setVehicle, findVehicle }}>
            {children}
        </SearchVehicleByVinDataContext.Provider>
    );
};